var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElizaShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 613.78 355.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8c47a;}.cls-2{fill:#001c56;}.cls-3{fill:#001c57;}.cls-4{fill:#000e26;}.cls-5{fill:#f675a6;}.cls-6{fill:#ffba55;}.cls-7{fill:#7e6da6;}.cls-8{fill:#021e54;}.cls-9{fill:#33347e;}.cls-10{fill:#bfbde7;}.cls-11{fill:#d2417d;}.cls-12{fill:#56679e;}.cls-13{fill:#4e4591;}.cls-14{fill:#4f166b;}.cls-15{stroke:#adccff;stroke-width:.46px;}.cls-15,.cls-16,.cls-17,.cls-18,.cls-19{fill:none;stroke-miterlimit:10;}.cls-16{stroke-linecap:round;}.cls-16,.cls-17{stroke:#4f166b;stroke-width:.57px;}.cls-18{stroke:#1b1464;}.cls-18,.cls-19{stroke-width:.34px;}.cls-19{stroke:#001c57;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M339.23,272.28h0c-1.5,2.31-3.99,3.79-6.74,4.01l-30.04,2.34c-1.17,.09-1.52-1.54-.43-1.95l16.73-6.15c3.87-1.42,5.24-6.2,2.7-9.45l-1.2-1.54h0c6.31-7.26,18.21-4.09,20.06,5.35l.17,.87c.44,2.25,0,4.59-1.26,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M380.14,186.2c0-19.97-43.54-36.15-97.25-36.15-53.71,0-97.25,16.19-97.25,36.15,0,52.93,43.54,95.85,97.25,95.85,53.71,0,97.25-42.91,97.25-95.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M396.27,152.02l-5.95,20.01c-.74,2.48-4.25,2.48-4.99,0l-5.95-20.01c-4.27-14.38-6.45-29.31-6.45-44.32v-7.15h29.78v7.15c0,15.01-2.17,29.93-6.45,44.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 387.55,
    cy: 104.33,
    rx: 17.96,
    ry: 6.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 369.63,
    y: 86.37,
    width: 35.88,
    height: 17.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M405.51,86.37c0,3.74-8.04,6.77-17.96,6.77-9.92,0-17.96-3.03-17.96-6.77s8.04-6.77,17.96-6.77c9.92,0,17.96,3.03,17.96,6.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M369.59,86.37c0,3.74,8.04,6.77,17.96,6.77,9.92,0,17.96-3.03,17.96-6.77,0-9.92-8.04-17.96-17.96-17.96-9.92,0-17.96,8.04-17.96,17.96Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M518.65,234.88l-104.81-12.35c-.34-.04-.68-.09-1.02-.14-65-8.85-131.22-.55-191.84,24.54-.93,.38-1.85,.77-2.78,1.16-19.88,8.36-38.44,19.55-55.23,33.09l-13.18,10.64-30.98-4.8,35.67-28.47c4.32-3.15,12.88-11.87,16.74-15.58,31.16-30.01,9.81-73.3-44.44-85.41l-48.48-13.27,10.23-12.28,72.3,10.55c27.77,3.21,78.87,6.93,78.87,6.93,44.25,1.92,92.73-6.93,123.89-31.93,.45-.36,9.43-9.23,9.43-9.23h0c5.58,2.79,14.43,3.66,22.12,2.12l5-1.25-1.65,1.84c-6.48,7.21-6.5,17.79-9.03,28.48-7.24,30.56,12.51,54.45,54.27,63.84l77.8,14.81-2.89,16.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M536.75,271.76l-7.26,24.44c-.9,3.03-5.19,3.03-6.09,0l-7.26-24.44c-5.22-17.57-7.87-35.79-7.87-54.12v-8.73h36.36v8.73c0,18.32-2.65,36.55-7.87,54.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M548.03,213.53c0,4.57-9.82,8.27-21.93,8.27-12.11,0-21.93-3.7-21.93-8.27,0-4.57,9.82-8.27,21.93-8.27,12.11,0,21.93,3.7,21.93,8.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 504.22,
    y: 191.6,
    width: 43.81,
    height: 21.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 526.1,
    cy: 191.6,
    rx: 21.93,
    ry: 8.27
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M504.17,191.6c0,4.57,9.82,8.27,21.93,8.27s21.93-3.7,21.93-8.27c0-12.11-9.82-21.93-21.93-21.93s-21.93,9.82-21.93,21.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.22,329.03l-7.26,24.44c-.9,3.03-5.19,3.03-6.09,0l-7.26-24.44c-5.22-17.57-7.87-35.79-7.87-54.12v-8.73h36.36v8.73c0,18.32-2.65,36.55-7.87,54.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M156.5,270.8c0,4.57-9.82,8.27-21.93,8.27-12.11,0-21.93-3.7-21.93-8.27s9.82-8.27,21.93-8.27c12.11,0,21.93,3.7,21.93,8.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 112.69,
    y: 248.87,
    width: 43.81,
    height: 21.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.5,248.87c0,4.57-9.82,8.27-21.93,8.27-12.11,0-21.93-3.7-21.93-8.27s9.82-8.27,21.93-8.27c12.11,0,21.93,3.7,21.93,8.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M112.64,248.87c0,4.57,9.82,8.27,21.93,8.27,12.11,0,21.93-3.7,21.93-8.27,0-12.11-9.82-21.93-21.93-21.93-12.11,0-21.93,9.82-21.93,21.93Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 279.91,
    cy: 178.13,
    rx: 62.91,
    ry: 17.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M318.39,167.93l-83.68,4.62-13.51-43.72c-3.09-10,4.11-20.21,14.56-20.67l76.59-3.36c10.57-.46,18.66,9.3,16.25,19.6l-10.2,43.54Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.31,135.59c.86-.04,1.72,.04,2.57,.15,.4,.05,1.72,.24,1.75,.65,.03,.47-1.56,.48-1.76,.47-2.13-.08-2.93,.29-3.67,.54,.69,0,4.17,.11,4.66,.25,.26,.08,1.6,.49,1,.9-.14,.09-.5,.11-1.23,.11-1,0-4.18,.33-4.49,.56,.79,.3,3.34,.09,4.11,.43,.36,.16,2.01,.44,1.65,1.13-.16,.3-1.68,.14-2.06,.07-.8-.15-2.59,.17-3.52,.19,.55,.35,4.09,.63,4.6,1.03,.25,.19,.24,.66-.27,.8-.22,.06-8.92-.65-10.06-.94,0,0-.77-.15-1.69-.39-.25-.07-.57-.28-.78-.44-1.59-1.32-.69-3.92,1.37-4.04,.15,0,.31,0,.47,0,1.02,.07,5.71-1.38,7.35-1.45Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 289.43,
    cy: 129.81,
    rx: 17.02,
    ry: 6.97,
    transform: "translate(29.92 312.23) rotate(-59.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 244.27,
    cy: 125.11,
    rx: 9.14,
    ry: 22.31,
    transform: "translate(-27.67 162.08) rotate(-34.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M276.63,120.93c.82,.37,1.56,.82,2.34,1.25-.8-.44-.08-.05,.28,.23,.46,.36,.9,.75,1.32,1.16,.32,.31,.61,.64,.92,.95-.65-.64-.01-.01,.24,.32,.59,.77,1.13,1.58,1.62,2.42,.23,.39,.43,.8,.66,1.18,.31,.51-.06-.15-.09-.22,.1,.21,.19,.41,.28,.62,.43,.97,.81,1.96,1.14,2.97,.28,.86,.53,1.73,.74,2.61,.05,.22,.1,.44,.15,.66,0,0,.18,.88,.09,.39s.07,.4,.07,.39c.06,.36,.12,.72,.17,1.08,1.37,9.03,.32,18.68,3.54,27.37,1.72,4.63,4.63,8.46,8.86,11.05,3.76,2.29,8.47,2.99,12.83,2.88,15.74-.38,25.18-23.07,27-26.03,.32-.52,.66-1.04,1-1.55,.14-.22,.29-.44,.44-.66-.32,.48-.08,.11,.11-.15,.73-.99,1.48-1.96,2.32-2.86,.37-.4,.78-.76,1.15-1.15,.4-.44-.09,.06-.17,.12,.24-.2,.49-.39,.74-.58,.5-.37,1.02-.72,1.55-1.03,.2-.12,.41-.22,.61-.34,.65-.37-.65,.35,.02,.02,2.04-1.02,5.08-1.54,5.08-1.54l-.25-5.69s-8.18-.21-13.4,4.98c-3.33,3.32-5.74,7.48-8.25,11.41-.27,.42-.54,.83-.81,1.25-.13,.19-.83,1.21-.57,.85s-.47,.64-.61,.83c-.34,.46-.69,.92-1.04,1.37-1.26,1.6-2.62,3.14-4.09,4.55-.16,.16-1.07,.99-.74,.7s-.61,.49-.79,.63c-.83,.64-1.69,1.24-2.58,1.79-.41,.25-.84,.49-1.26,.72-.87,.48,.38-.12-.48,.23-.91,.38-1.82,.71-2.77,.97-.2,.06-1.43,.32-.86,.22s-.68,.09-.89,.11c-.98,.11-1.95,.14-2.94,.12-1.07-.01,.7,.13-.35-.04-.44-.07-.88-.13-1.32-.22s-.86-.21-1.29-.31c-.1-.03-.83-.23-.16-.03s-.22-.09-.35-.15c-.47-.2-.93-.42-1.38-.67-.38-.21-1.09-.7-.33-.14-.35-.26-.7-.53-1.03-.83-.17-.15-.33-.3-.49-.45-.07-.07-.72-.75-.33-.31,.33,.36-.43-.59-.56-.77-.26-.39-.51-.78-.74-1.19-.11-.2-.22-.41-.33-.62,.05,.09,.3,.74,.1,.18-.18-.52-.42-1.02-.6-1.54-.31-.9-.55-1.82-.78-2.74-.25-.99,.06,.5-.11-.5-.09-.55-.18-1.1-.26-1.65-.31-2.23-.48-4.48-.63-6.72-.3-4.56-.46-9.14-1.23-13.65-1.66-9.6-6.2-19.59-15.59-23.81-2.56-1.15-5.99-.41-7.24,2.32-1.16,2.53-.42,6.01,2.32,7.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M298.14,115h0c-1.97,1.84-7.37,3.86-10.53,9.78-4.01,7.5-5.67,18.96-5.67,18.96,0,0-9.84-15.69-1.83-25.72h0c6.75-9.31,18.03-3.02,18.03-3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M248.23,126.55c-2.12,9.77,1.25,18.6,7.88,31.23,2.14,4.07-32.94,22.42-32.94,22.42,11.16,17.26,37.37,19.63,37.37,19.63,11.9-2.93,20.41-16.58,23.17-24.93,0,0-2.02-4.8-3.36-7.18,0,0-2.55-10.73,3.55-18.15,8.84-10.74,5.37-16.64,3.66-21.24-6.22-16.79-16.92-20.41-28.9-13.96,0,0-8.32,2.49-10.43,12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M276.87,142.45l-.76-1.3c-6.81-11.62-15.5-22.03-25.72-30.79h0c11.48-5.84,25.21-5.11,36.01,1.92l1.72,1.12-11.25,29.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M276.87,142.45l-3.14-12.13c-1.61-5-5.21-11.13-8.39-15.3-1.25-1.63-2.86-3.2-6.09-5.49h0c7.7-2.97,13.67-2.83,21.2,1.33h0c-.07,6.68-.64,13.34-1.7,19.94l-1.88,11.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M272.66,114.36c-.3,2.77-3.63,.9-4.9-.96-2.5-3.67-2.59-5.39-2.59-5.39h0c-.27,1.28,4.64-11.49,4.64-11.49l7.45,4.24h0c-2.82,3.24-4.07,8.73-4.6,13.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M276.95,141.96h0c.69,4.92-.04,6.57-1.85,14.54l-.21,.52"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M269.38,161.72c-1.32-.17-8.16,.39-13.27-3.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M280.64,161.65s-1.19,.75-3.08,.59"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 273.43,
    cy: 161.47,
    rx: 4.11,
    ry: 3.98,
    transform: "translate(66.36 402.21) rotate(-79.86)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M248.78,95.66c1.59,5.08,9.31,8.66,15.93,6.14,5.12-1.94,8.89-5.09,9.96-9.37h0c-4.5,1.88-9.48,2.26-14.21,1.06l-2.59-.66c-1.49,5.56-7.81,3.9-9.09,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293.53,73c2.69,3.55,1.03,9.27-2.22,11.12-1.22,.7-9.03,5.83-18.14-7.42-.9-1.31-2.09-4.25-1.38-6,.33-.82,1.19-1.68,2.01-1.99,1.42-.54,2.45,.38,3.57,1.94,0,0,1.76,4.07,6.87,6.27,6.42,2.76,9.8-3.38,9.29-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M291.08,76.06c.39-1.23,.69-2.49,.85-3.77,.37-2.93,.31-7.96-5.27-13.38-3.92-3.8-16.87-7.83-29.39,.59-4.22,2.84-8.47,9.5-6.61,17.56,1.63,7.08-.9,7.29-3.3,7.66-2.05,.31-3.85-2.66-3.97-2.88,0,0-.12,5.2,1.96,8.47,4.34,6.82,15.18,9.29,23.31,5.59,20.39,4.22,29.85-12.44,27.99-16.62,.19,.37-2.04,2.57-4.49,1.08-3.21-1.95-1.82-2-1.08-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.46,66.44l-1.52,.61s-.87,.47-1.4,.41c-13.25-1.43-4.72,10.14-11.28,17.69-3.57,4.11-10.52,2.94-10.68,2.99-.82,.26-1.49,.88-1.91,1.62-1.11,1.95-.07,5.52,3.26,7,1.4,.62,3.03,.11,4.2-.78,3.17,2.09,6.66,4.86,10.09,6.21,8.37,3.3,15.99,3.42,15.99,3.42,.74-.96,5.3-12.36,3.03-22.14-.32-1.39-1.28-10.24-4.65-15.42-1.1-1.69-3.25-2.36-5.12-1.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "286.64 82.76 291.32 90.34 287.22 92.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M290.58,95.09c-.7,5.21-7.72,7.23-11.52,1.49l11.52-1.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M245.38,79.05c.09,3.65,4.08,6.47,7.11,5.99,1.14-.18,8.76-.88,7.83-14.03-.09-1.3-.83-3.79-2.18-4.55-.63-.35-1.62-.47-2.31-.25-1.18,.38-1.37,1.5-1.3,3.07,0,0,.95,3.51-1.2,7.53-2.7,5.05-8.01,2.85-7.95,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M279.46,75.71c3.2,1.75,7.64-.3,8.74-3.16,.41-1.08,3.63-8.03-8.23-13.8-1.17-.57-3.7-1.18-5.03-.39-.62,.37-1.22,1.17-1.37,1.87-.26,1.21,.61,1.94,2.01,2.66,0,0,3.52,.93,5.92,4.81,3.02,4.86-1.55,8.36-2.04,8.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M265.77,78.1c5.26,4.02,14.54-3.32,15-8.35,.18-1.9,4.93-9.23-14.38-12.22-1.91-.3-5.79,.04-7.39,1.95-.75,.89-1.3,2.45-1.24,3.63,.1,2.03,1.63,2.72,3.93,3.14,0,0-1.45-3.32,3.52,1.51,6.24,6.07,1.41,10.63,.56,10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.75,98.57c-1.91,1.71-4.92,2.07-7.47,.31,1.39-1.34,5.66-1.59,7.47-.31Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 287.5,
    cy: 81.85,
    rx: 1.5,
    ry: 2.73,
    transform: "translate(-9.26 45.98) rotate(-9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 276.13,
    cy: 84.69,
    rx: 1.5,
    ry: 2.73,
    transform: "translate(-12.57 76.32) rotate(-15.39)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.11,162.84c.79-.35,1.62-.58,2.45-.8,.39-.1,1.69-.4,1.86-.03,.2,.43-1.28,1.01-1.47,1.07-2.01,.7-2.62,1.33-3.23,1.83,.64-.25,3.93-1.41,4.44-1.45,.27-.02,1.67-.13,1.26,.48-.09,.14-.42,.29-1.11,.55-.93,.36-3.78,1.82-3.99,2.14,.85,0,3.14-1.12,3.99-1.09,.39,.02,2.04-.31,1.95,.46-.04,.34-1.52,.74-1.9,.81-.8,.15-2.36,1.1-3.21,1.45,.64,.13,4.04-.89,4.66-.71,.3,.09,.46,.53,.04,.85-.18,.14-8.55,2.62-9.72,2.76,0,0-.77,.14-1.71,.25-.26,.03-.63-.05-.88-.13-1.96-.66-2.06-3.4-.19-4.26,.14-.06,.29-.12,.44-.17,.97-.31,4.82-3.35,6.33-4.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.07,166.78l2.06-4.33c.24-.51,.9-1.09,1.25-.64,.11,.14,.12,.33,.11,.51-.05,1.43-.75,2.75-1.44,4.01-.21,.39-.45,.8-.84,1s-.99,.04-1.08-.39"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M244.33,166.52c-5.25,1.21-9.75,1.91-11.52,2.15-18.31,2.46-29.31-4.08-32.94-8.77-1.56-2.02-4.57-6.41-1.82-13.68,6.9-18.31,42.64-21.94,44.92-22.3,11.85-1.9,8.58-8.95,8.49-9.12-2.16-4.11-9.89-3.25-12.45-2.8-11.28,2-44.62,11.21-50.25,33.04-1.38,5.33-1.27,10.08,3.05,17.33,2.92,4.91,13.7,13.29,28.03,13.27,4.69,0,14.18-.26,24.98-3.68l-.49-5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M249.01,142.48l-.02-.41c-2.51-13.55-7.71-26.37-15.56-36.13h0s13.11-1.01,22.04,8.49h0c8.39,8.12-6.46,28.05-6.46,28.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.12,178.96l-5.95,20.01c-.74,2.48-4.25,2.48-4.99,0l-5.95-20.01c-4.27-14.38-6.45-29.31-6.45-44.32v-7.15h29.78v7.15c0,15.01-2.17,29.93-6.45,44.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M91.36,131.27c0,3.74-8.04,6.77-17.96,6.77-9.92,0-17.96-3.03-17.96-6.77,0-3.74,8.04-6.77,17.96-6.77,9.92,0,17.96,3.03,17.96,6.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 55.48,
    y: 113.31,
    width: 35.88,
    height: 17.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.36,113.31c0,3.74-8.04,6.77-17.96,6.77-9.92,0-17.96-3.03-17.96-6.77s8.04-6.77,17.96-6.77c9.92,0,17.96,3.03,17.96,6.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M55.44,113.31c0,3.74,8.04,6.77,17.96,6.77,9.92,0,17.96-3.03,17.96-6.77,0-9.92-8.04-17.96-17.96-17.96-9.92,0-17.96,8.04-17.96,17.96Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M234.49,192.86c0,6.63,23.48,12.01,52.44,12.01,28.96,0,52.44-5.38,52.44-12.01,0-17.59-23.48-31.85-52.44-31.85s-52.44,14.26-52.44,31.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M152.18,149.46c0,2.16,4.65,3.91,10.38,3.91,5.73,0,10.38-1.75,10.38-3.91,0-5.73-4.65-10.38-10.38-10.38-5.73,0-10.38,4.65-10.38,10.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M157.8,148.99c0,.95,2.03,1.71,4.54,1.71,2.51,0,4.54-.77,4.54-1.71,0-2.51-2.03-4.54-4.54-4.54-2.51,0-4.54,2.03-4.54,4.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M356.49,123.07c0,2.16,4.65,3.91,10.38,3.91,5.73,0,10.38-1.75,10.38-3.91,0-5.73-4.65-10.38-10.38-10.38-5.73,0-10.38,4.65-10.38,10.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M362.1,122.61c0,.95,2.03,1.71,4.54,1.71,2.51,0,4.54-.77,4.54-1.71,0-2.51-2.03-4.54-4.54-4.54-2.51,0-4.54,2.03-4.54,4.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M187.19,234.11c0,3.53,7.58,6.38,16.92,6.38s16.92-2.86,16.92-6.38c0-9.35-7.58-16.92-16.92-16.92-9.35,0-16.92,7.58-16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.06,232.11c0,2.23,4.79,4.03,10.69,4.03s10.69-1.81,10.69-4.03c0-5.9-4.79-10.69-10.69-10.69-5.9,0-10.69,4.79-10.69,10.69Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M389.57,201.68c0,3.53,7.58,6.38,16.92,6.38,9.35,0,16.92-2.86,16.92-6.38,0-9.35-7.58-16.92-16.92-16.92s-16.92,7.58-16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M394.96,199.5c0,2.33,5,4.21,11.17,4.21,6.17,0,11.17-1.89,11.17-4.21,0-6.17-5-11.17-11.17-11.17-6.17,0-11.17,5-11.17,11.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M185.65,157.56c0,32.77,43.54,59.34,97.25,59.34,53.71,0,97.25-26.57,97.25-59.34C380.14,70.67,336.6,.23,282.89,.23c-53.71,0-97.25,70.44-97.25,157.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M147.97,113.2c0,11.47-33.07,20.78-73.87,20.78-40.8,0-73.87-9.3-73.87-20.78s33.07-20.78,73.87-20.78c40.8,0,73.87,9.3,73.87,20.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M114.1,99.46c17.42,3.13,28.64,8.04,28.64,13.55,0,5.27-10.26,9.98-26.39,13.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M103.38,102.74c17.68,.8,33.79,6.33,34.36,10.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M34.89,126.32c-17.42-3.13-28.64-8.04-28.64-13.55s10.26-9.98,26.39-13.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M45.61,123.04c-17.68-.8-33.79-6.33-34.36-10.66"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M222.02,247.58c0,13.58-39.15,24.6-87.45,24.6-48.3,0-87.45-11.01-87.45-24.6s39.15-24.6,87.45-24.6c48.3,0,87.45,11.01,87.45,24.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M181.92,231.31c20.62,3.71,33.9,9.51,33.9,16.04s-12.14,11.82-31.24,15.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M169.23,235.19c20.93,.95,40,7.49,40.68,12.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M88.16,263.1c-20.62-3.71-33.9-9.51-33.9-16.04s12.14-11.82,31.24-15.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M100.84,259.22c-20.93-.95-40-7.49-40.68-12.62"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M461.23,85.69c0,11.47-33.07,20.78-73.87,20.78-40.8,0-73.87-9.3-73.87-20.78,0-11.47,33.07-20.78,73.87-20.78,40.8,0,73.87,9.3,73.87,20.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M427.35,71.95c17.42,3.13,28.64,8.04,28.64,13.55s-10.26,9.98-26.39,13.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M416.63,75.23c17.68,.8,33.79,6.33,34.36,10.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M348.15,98.81c-17.42-3.13-28.64-8.04-28.64-13.55s10.26-9.98,26.39-13.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M358.86,95.53c-17.68-.8-33.79-6.33-34.36-10.66"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 526.1,
    cy: 191.6,
    rx: 87.45,
    ry: 24.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M573.45,175.32c20.62,3.71,33.9,9.51,33.9,16.04s-12.14,11.82-31.24,15.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M560.76,179.21c20.93,.95,40,7.49,40.68,12.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M479.69,207.12c-20.62-3.71-33.9-9.51-33.9-16.04s12.14-11.82,31.24-15.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M492.37,203.24c-20.93-.95-40-7.49-40.68-12.62"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M250.79,280.47h0c-1.5,2.31-3.99,3.79-6.74,4.01l-30.04,2.34c-1.17,.09-1.52-1.54-.43-1.95l16.73-6.15c3.87-1.42,5.24-6.2,2.7-9.45l-1.2-1.54h0c6.31-7.26,18.21-4.09,20.06,5.35l.17,.87c.44,2.25,0,4.59-1.26,6.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 358.58,
    y: 143.05,
    width: 4.48,
    height: 18.23,
    transform: "translate(67.52 -107.29) rotate(18.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 363.78,
    cy: 143.39,
    r: 5.53
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M342.15,175.22c0,3.73,6.81,6.76,15.2,6.76,8.4,0,15.2-3.03,15.2-6.76,0-9.9-6.81-17.92-15.2-17.92-8.4,0-15.2,8.02-15.2,17.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.82,139.69l3.64,3.12c.43,.37,.81,1.15,.3,1.37-.16,.07-.35,.03-.53-.02-.92-.28-1.71-.83-2.44-1.46-.36-.31-3.51-.26-3.85-.59-.32-.31-1.12-1.24-1.21-1.67s3.48-.75,3.93-.72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElizaShip);
export default __webpack_public_path__ + "static/media/eliza-ship.a72b6dfcfbce3a25a244d3a2a7e3dce5.svg";
export { ForwardRef as ReactComponent };